"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgWarning = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14 }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#FECA63", d: "M6.206.987.082 12.11c-.278.648.186 1.39.835 1.39h12.156c.742 0 1.113-.742.835-1.39L7.784.987c-.279-.65-1.207-.65-1.578 0Z" }),
        React.createElement("path", { fill: "#000", d: "M7.642 10.72v.926H6.25v-.927h1.392Zm0-6.49v5.562H6.25V4.231h1.392Z" }))));
const Memo = (0, react_1.memo)(SvgWarning);
exports.default = Memo;
//# sourceMappingURL=Warning.js.map